module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp1_6.883b493b.png";